<template>
  <svg
    :class="'c-file-icon c-file-icon--'+type"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 48 48"
  >
    <path fill="none" d="M6 1h37v46H6z"></path>
    <path fill="none" d="M6 1h37v46H6z"></path>
    <path fill="none" d="M6 1h37v46H6z"></path>
    <path
      class="c-file-icon__frame"
      fill="#768692"
      d="M31.1 14.43a1.87 1.87 0 0 1-1.9-1.84V1H10.73A4.7 4.7 0 0 0 6 5.6v36.8a4.7 4.7 0 0 0 4.72 4.6h27.56A4.7 4.7 0 0 0 43 42.4V14.43H31.1z"
    ></path>
    <path fill="#fff" d="M30.97 14.4H43L29.24 1v11.71c.06.9.82 1.63 1.73 1.7z"></path>
    <path fill="#000" fill-opacity="0.14" d="M43 23.94v-9.48H31.07L43 23.94z"></path>

    <g v-if="type == 'link'" transform="translate(15 22)">
      <path fill="none" d="M1.33 1h16.52v16.51H1.33z"></path>
      <path
        fill="none"
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M7.91 10.08a4.15 4.15 0 0 0 5.82.84c.17-.1.3-.25.45-.39l2.5-2.49a4.15 4.15 0 0 0-.12-5.88 4.2 4.2 0 0 0-5.78 0L9.35 3.59"
      ></path>
      <path
        fill="none"
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M11.26 8.43a4.15 4.15 0 0 0-5.82-.84c-.17.11-.3.25-.45.4l-2.5 2.49a4.15 4.15 0 0 0 .12 5.88 4.2 4.2 0 0 0 5.78 0l1.43-1.43"
      ></path>
    </g>

    <text class="c-file-icon__text" v-else>
      <tspan x="9.48" y="40.82">.{{type}}</tspan>
    </text>
  </svg>
</template>

<script>
export default {
  name: 'file-icon',

  props: ['type'],
};
</script>

<style lang="scss">
.c-file-icon {
  width: 48px;
  height: 48px;

  &__text {
    font-size: 11px;
    font-style: 65 Bold;
    font-weight: bold;
    letter-spacing: 0em;
    white-space: pre;
    fill: $colour-nhs-white;
    letter-spacing: 0.5px;
  }

  &--pdf &__frame {
    fill: #e3793b;
  }
  &--csv &__frame,
  &--xlsx &__frame,
  &--xls &__frame {
    fill: #27ae60;
  }
  &--doc &__frame,
  &--docx &__frame {
    fill: #2776ae;
  }
  &--link &__frame {
    fill: #59bfe9;
  }
  &--ppt &__frame,
  &--pptx &__frame {
    fill: #ae3727;
  }
}
</style>

